'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  /*@ngInject*/
  function _class($http, $filter, ColorFinder) {
    _classCallCheck(this, _class);

    this.$http = $http;
    this.$filter = $filter;
    this.ColorFinder = ColorFinder;
    this.total = 0;
  }

  _createClass(_class, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.search = {};
      this.$http.get('/api/lessons/').then(function (res) {
        _this.lessons = res.data;
      });

      this.$http.get('/api/students').then(function (response) {
        _this.students = response.data.filter(function (student) {
          return student.isActive;
        });
      });
    }
  }, {
    key: 'returnFilter',
    value: function returnFilter(results, $query) {
      return results.filter(function (item) {
        return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
      });
    }
  }, {
    key: 'processFound',
    value: function processFound(found) {
      var text = '';

      for (var key in found) {
        text += key + ': ';
        text += found[key] + ', ';
      }

      return text;
    }
  }, {
    key: 'processLessons',
    value: function processLessons() {
      var _this2 = this;

      var _search = this.search,
          start = _search.start,
          end = _search.end,
          student = _search.student;


      student = student[0];
      var temper = this.lessons.filter(function (lesson) {
        return !lesson.isHidden;
      });
      temper = temper.filter(function (lesson) {
        return student._id === lesson.clientUID;
      });
      temper = temper.map(function (lesson) {
        return _this2.colourInstances(lesson, start, end);
      });

      var counts = [];

      temper.forEach(function (lesson) {

        var lessonCount = lesson.found;

        if (!lessonCount) {
          return;
        }

        for (var key in lessonCount) {
          if (key.includes('red')) {
            continue;
          }
          var countIndex = counts.findIndex(function (count) {
            return count[0] === key;
          });

          if (countIndex === -1) {
            counts.push([key, lessonCount[key]]);
          } else {
            counts[countIndex][1] += lessonCount[key];
          }
        }
      });

      this.counts = counts;

      this.total = 0;
      this.counts.forEach(function (count) {
        _this2.total += count[1];
      });
    }
  }, {
    key: 'colourInstances',
    value: function colourInstances(lesson, start, end) {
      var msDay = 1000 * 60 * 60 * 24;

      lesson.newDate = this.$filter('reparseDate')(lesson.date);
      lesson.found = {};

      if (lesson.newDate > end) {
        return lesson;
      }

      var maxPossible = Math.floor((end.getTime() - lesson.newDate.getTime()) / msDay / lesson.frequency) + 1;

      if (lesson.instances !== 0 && lesson.instances < maxPossible) {
        maxPossible = lesson.instances;
      }

      var startIndex = 0;
      if (start > lesson.newDate) {
        var dif = (start.getTime() - lesson.newDate.getTime()) / msDay;
        startIndex = Math.ceil(dif / lesson.frequency);
      }

      for (var i = startIndex; i < maxPossible; i++) {
        if (lesson.overwriteVisibility && lesson.overwriteVisibility[i] === true) {
          continue;
        }

        var fonCol = this.ColorFinder(lesson, i);

        if (lesson.found[fonCol]) {
          lesson.found[fonCol] += 1;
        } else {
          lesson.found[fonCol] = 1;
        }
      }

      return lesson;
    }
  }]);

  return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/admin/student-info/student-info.controller.js